import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { TID } from "@/lib/testIds";

const LABELS = {
  app: "App",
  dashboard: "Dashboard",
  songwriters: "Songwriters",
  "music-industry": "Music Industry",
  services: "Services",
  merchandising: "Merchandising",
  radio: "Radio",
  workshops: "Workshops",
  messages: "Messages",
  notifications: "Notifications",
  profile: "Profile",
  settings: "Settings",
  admin: "Admin",
  waitlist: "Waitlist",
};

export default function Breadcrumbs() {
  const location = useLocation();
  const parts = location.pathname.split("/").filter(Boolean);

  const crumbs = parts.map((p, i) => ({
    label: LABELS[p] || p,
    to: "/" + parts.slice(0, i + 1).join("/"),
    isLast: i === parts.length - 1,
  }));

  return (
    <nav
      data-testid={TID.shell.breadcrumbs}
      aria-label="Breadcrumb"
      className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] font-display"
    >
      <Link to="/" className="text-white/40 hover:text-gold transition-colors">
        Home
      </Link>
      {crumbs.map((c) => (
        <React.Fragment key={c.to}>
          <ChevronRight className="h-3 w-3 text-white/30" />
          {c.isLast ? (
            <span className="text-gold">{c.label}</span>
          ) : (
            <Link
              to={c.to}
              className="text-white/40 hover:text-gold transition-colors"
            >
              {c.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
